export const getPictureSourceSet = (imageUrl: string, fileFormat: 'jpg' | 'webp') => `https://cms.brnstc.de/product_images/180x246p${formatImageUrl(imageUrl, fileFormat)} 120w,
    https://cms.brnstc.de/product_images/287x393p${formatImageUrl(imageUrl, fileFormat)} 180w,
    https://cms.brnstc.de/product_images/360x492p${formatImageUrl(imageUrl, fileFormat)} 287w,
    https://cms.brnstc.de/product_images/435x596p${formatImageUrl(imageUrl, fileFormat)} 360w,
    https://cms.brnstc.de/product_images/574x786p${formatImageUrl(imageUrl, fileFormat)} 435w,
    https://cms.brnstc.de/product_images/870x1192p${formatImageUrl(imageUrl, fileFormat)} 574w`;

export const getSinglePictureUrl = (imageUrl: string, format: 'jpg' | 'webp', size = '180x246') => {
  return `https://cms.brnstc.de/product_images/${size}p${formatImageUrl(imageUrl, format)}`;
};

export const formatImageUrl = (imageUrl: string, format: 'jpg' | 'webp') => {
  const formattedImageUrl = format === 'webp' ? imageUrl.replace('.jpg', '.webp') : imageUrl;
  return formattedImageUrl.startsWith('/') ? formattedImageUrl : `/${formattedImageUrl}`;
};
